@if (filteredWorkers()?.length) {
  <form #workerForm="ngForm" role="form" aria-label="Worker selection form" novalidate>
    <div
      class="cbsw-workers-selection-step"
      role="region"
      aria-label="Worker selection"
      id="worker-selection-section"
      [attr.aria-busy]="!workers()"
      [attr.aria-live]="'polite'"
    >
      <!-- Show this section if worker length is greater than 10 -->
      @if (workersView === workersViews.DROPDOWN) {
      <div class="row">
        <div class="col-md-12">
          <label for="worker-select" class="step-element-title" id="worker-select-label">
            <app-csw-text
              [text]="widgetResourceHeadingTemplate | translation : 'template_content' : lang"
              customClass="step-element-title fw-600"
              [ariaLabel]="'Select a worker'"
            />
          </label>
          <ng-select
            id="worker-select"
            name="worker-select"
            placeholder=""
            [multiple]="false"
            [(ngModel)]="selectedWorkerId"
            (change)="onWorkerChange()"
            [required]="true"
            [items]="filteredWorkers()"
            bindValue="id"
            bindLabel="name"
            #workerControl="ngModel"
            [ngClass]="{
              'is-invalid': workerControl.touched && workerControl.invalid
            }"
            [attr.aria-label]="'Select a worker'"
            [attr.aria-required]="true"
            [attr.aria-invalid]="workerControl.touched && workerControl.invalid"
            [attr.aria-describedby]="'worker-error-message worker-select-label'"
            [attr.aria-controls]="'worker-options-list'"
            role="combobox"
            aria-haspopup="listbox"
            [attr.aria-expanded]="false"
            tabindex="0"
            [attr.aria-activedescendant]="selectedWorkerId ? 'worker-option-' + selectedWorkerId : null"
          >
            <ng-template ng-option-tmp let-worker="item">
              <div
                class="d-flex align-items-center"
                role="option"
                [id]="'worker-option-' + worker.id"
                [attr.aria-selected]="selectedWorkerId === worker.id"
                [attr.aria-label]="(worker | translation : 'resource_name' : lang) + (selectedWorkerId === worker.id ? ' - Selected' : ' - Not selected')"
                [attr.aria-posinset]="$index + 1"
                [attr.aria-setsize]="filteredWorkers().length"
                [attr.aria-disabled]="false"
              >
                <div class="avatar" role="presentation">
                  <img #image
                    class="resource-avatar rounded-circle"
                    height="35"
                    width="35"
                    [src]="worker.avatar !== null ? workerAvatarBaseUrl + worker.uuid + '/thumb_' + worker.avatar : baseUrl + '/img/sample-avatar.png'"
                    (error)="image.src= baseUrl + '/img/sample-avatar.png'"
                    [alt]="(worker | translation : 'resource_name' : lang) + ' avatar'"
                  />
                </div>
                @if (worker.id === 0) {
                  @if (widgetService?.widgetConf?.partner?.egal_wer_show === 1) {
                    <div class="d-flex align-items-center" role="group" aria-label="Anyone option details">
                      <div class="description">
                        <div class="cbw-title" role="heading" aria-level="3">
                          {{ widgetAnyoneLabelTemplate | translation : "template_content" : lang }}
                        </div>
                        <div class="cbw-function" role="text" aria-label="Description">
                          {{ widgetAnyoneDescTemplate | translation : "template_content" : lang }}
                        </div>
                      </div>
                    </div>
                  }
                } @else {
                  <div class="d-flex align-items-center" role="group" [attr.aria-label]="(worker | translation : 'resource_name' : lang) + ' details'">
                    <div class="description">
                      <div class="cbw-title" role="heading" aria-level="3">
                        @if (worker.is_resource === 0) {
                          {{ worker.resource_name }}
                        } @else if (worker.is_resource === 1) {
                          {{ worker | translation : "booking_label" : lang }}
                        }
                      </div>
                      @if (worker.is_resource === 0) {
                        <div class="cbw-function" role="text" aria-label="Job title">
                          {{ worker | translation : "job_title" : lang }}
                        </div>
                      } @else if (worker.is_resource !== 0) {
                        <div class="cbw-function" role="text" aria-label="Description">
                          {{ worker | translation : "description" : lang }}
                        </div>
                      }
                      @if (widgetShowResourceStoreName === 1) {
                        @let optStore = displayStore(worker);
                        <div class="cbw-worker-store-location" role="group" aria-label="Store location">
                          <span class="cbw-worker-store-location-name" role="text">{{ optStore | translation : "name" : lang }}</span>
                          @if (optStore.is_online === 0) {
                            <span class="cbw-worker-store-location-separator" aria-hidden="true">,&nbsp;</span>
                            <span class="cbw-worker-store-location-address whitespace-pre-line" role="text">
                              @let addressInput = {
                                street: optStore.street,
                                zip: optStore.zip,
                                city: optStore.city,
                                country: optStore.country | translation : "name" : lang,
                                country_code: optStore.country?.identifier,
                              };
                              {{ addressInput | addressFormat: 'single' }}
                            </span>
                          }
                        </div>
                      }
                      @if (worker?.attributes?.length) {
                        <div class="cbw-worker-attributes" role="group" aria-label="Worker attributes">
                          @for (attribute of worker.attributes; track attribute.uuid) {
                            @if (attribute.type === workerAttributeTypes.SELECT) {
                              <div class="attribute-container cbw-attribute-container" role="group" [attr.aria-label]="(attribute | translation: 'name': lang)">
                                <div class="cbw-attribute" role="text">
                                  {{ attribute | translation: 'name': lang }}:
                                </div>
                                <div class="attribute-value-section" role="list" [attr.aria-label]="(attribute | translation: 'name': lang) + ' values'">
                                  @for (value of attribute.attributes_values; track value.uuid; let last = $last) {
                                    <div class="attribute-value-img" role="listitem">
                                      @if (value.icon_url !== null) {
                                        <img
                                          #image
                                          class="cbw-attribute-icon"
                                          [alt]="value.value"
                                          src="{{ value.icon_url }}"
                                          (error)="image.src= baseUrl + '/img/sample-avatar.png'"
                                        />
                                      }
                                      <div class="cbw-attribute-value" role="text">
                                        {{ value.value }}
                                        @if (!last) { <span aria-hidden="true">|</span> }
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            } @else {
                              <div class="cbw-attribute cbw-attribute-container" role="group" [attr.aria-label]="(attribute | translation: 'name': lang)">
                                <span role="text">{{ attribute | translation: 'name': lang }}:</span>
                                @if (attribute.attributes_values?.length) {
                                  <span role="text">{{ +attribute.attributes_values[0].value === 1 ? ( 'yes' | translate ): ( 'no' | translate ) }}</span>
                                }
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </ng-template>

            <ng-template ng-label-tmp let-worker="item">
              <div
                class="d-flex align-items-center gap-2"
                role="option"
                [id]="'worker-selected-' + worker.id"
                [attr.aria-selected]="true"
                [attr.aria-label]="(worker | translation : 'resource_name' : lang) + ' - Selected'"
                [attr.aria-hidden]="false"
              >
                <div class="avatar" role="presentation">
                  <img #image
                    class="default-avatar rounded-circle"
                    height="35"
                    width="35"
                    [src]="worker.avatar !== null ? workerAvatarBaseUrl + worker.uuid + '/thumb_' + worker.avatar : baseUrl + '/img/sample-avatar.png'"
                    (error)="image.src = baseUrl + '/img/sample-avatar.png'"
                    [alt]="(worker | translation : 'resource_name' : lang) + ' avatar'"
                  />
                </div>
                @if (worker.id === 0) {
                  <div
                    class="worker-name cbw-worker-name"
                    role="text"
                    [innerHTML]="(widgetAnyoneLabelTemplate | translation: 'template_content': lang) | trustHtml"
                    [attr.aria-label]="widgetAnyoneLabelTemplate | translation: 'template_content': lang"
                  ></div>
                } @else {
                  <div role="group" [attr.aria-label]="(worker | translation : 'resource_name' : lang) + ' details'">
                    <div class="worker-name cbw-worker-name" role="heading" aria-level="3">
                      {{ worker | translation: 'resource_name': lang }}
                    </div>
                    @if (worker.is_resource === 0) {
                      <div class="cbw-function" role="text" aria-label="Job title">
                        {{ worker | translation : "job_title" : lang }}
                      </div>
                    } @else if (worker.is_resource !== 0) {
                      <div class="cbw-function" role="text" aria-label="Description">
                        {{ worker | translation : "description" : lang }}
                      </div>
                    }
                  </div>
                }
              </div>
            </ng-template>
          </ng-select>
          <div
            id="worker-error-message"
            role="alert"
            aria-live="assertive"
            [attr.aria-hidden]="!workerControl.touched || workerControl.valid"
            [attr.aria-relevant]="'additions removals'"
          >
            @if (workerControl.touched && !workerControl.valid) {
              <div class="text-danger">
                @if (workerControl.errors.required) {
                  {{ bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_INPUT_DEFAULT_ERROR_VALIDATION_MESSAGE, type: 'template' } | translation: 'template_content': lang }}
                }
              </div>
            }
          </div>
        </div>
      </div>
      }
      <!-- Show this section if worker length is less than 10 -->
      @else if (workersView === workersViews.CARD) {
      <div role="heading" aria-level="2" id="worker-selection-heading">
        <app-csw-text
          [text]="widgetResourceHeadingTemplate | translation : 'template_content' : lang"
          customClass="step-element-title fw-600"
          [ariaLabel]="'Select a worker'"
        />
      </div>
      <div
        class="row cbsw-workers-selection"
        role="listbox"
        id="worker-options-list"
        aria-label="Available workers"
        [attr.aria-multiselectable]="false"
        [attr.aria-labelledby]="'worker-selection-heading'"
        [attr.aria-orientation]="'horizontal'"
      >
        @if (workers()?.length !== 1 && widgetService?.widgetConf?.partner?.egal_wer_show === 1) {
          <div
            class="worker-slot-card col-md-6 col-lg-4 mt-3"
            role="option"
            id="worker-option-anyone"
            [attr.aria-selected]="selectedWorkerId === 0"
            [attr.aria-label]="(widgetAnyoneLabelTemplate | translation : 'template_content' : lang) + (selectedWorkerId === 0 ? ' - Selected' : ' - Not selected')"
            tabindex="0"
            (click)="selectedWorkerId = 0; onWorkerChange()"
            (keydown.enter)="selectedWorkerId = 0; onWorkerChange(); $event.preventDefault()"
            (keydown.space)="selectedWorkerId = 0; onWorkerChange(); $event.preventDefault()"
            [attr.aria-posinset]="1"
            [attr.aria-setsize]="workers().length + 1"
          >
            <app-info-card
              [showCardBorder]="true"
              [showShadow]="false"
              [showBody]="true"
              [isSelected]="selectedWorkerId === 0"
              [selectedCardColor]="widgetService?.widgetConf?.header_background_color"
              [attr.aria-label]="(widgetAnyoneLabelTemplate | translation : 'template_content' : lang) + (selectedWorkerId === 0 ? ' - Selected' : ' - Not selected')"
              [attr.aria-pressed]="selectedWorkerId === 0"
              role="article"
            >
              <div cardBody role="group" [attr.aria-label]="(widgetAnyoneLabelTemplate | translation : 'template_content' : lang) + ' details'">
                <div class="d-flex align-items-center justify-content-between cbsw-workers-avatar-wrapper">
                  <div class="d-flex align-items-center cbsw-workers-avatar-sub-wrapper">
                    <div class="avatar" role="presentation">
                      <img
                        class="default-avatar rounded-circle"
                        src="{{ baseUrl }}/img/sample-avatar.png"
                        height="200"
                        alt="Anyone Avatar"
                        aria-hidden="true"
                      />
                    </div>
                    <div class="description">
                      <div class="cbw-title">
                        {{ widgetAnyoneLabelTemplate | translation : "template_content" : lang }}
                      </div>
                      <div class="cbw-function">
                        {{ widgetAnyoneDescTemplate | translation : "template_content" : lang }}
                      </div>
                    </div>
                  </div>
                  <div class="next-arrow-container">
                    @if (selectedWorkerId === 0) {
                      <span
                        (click)="next()"
                        role="button"
                        tabindex="0"
                        [attr.aria-label]="'Continue to next step'"
                        (keydown.enter)="next(); $event.preventDefault()"
                        (keydown.space)="next(); $event.preventDefault()"
                        [attr.aria-keyshortcuts]="'Alt+ArrowRight'"
                      >
                        <div class="next-button-wrapper">
                          <img
                            [src]="baseUrl + '/images/next_icon_widget.svg'"
                            width="26px"
                            alt="Continue"
                            aria-hidden="true"
                          />
                        </div>
                      </span>
                    }
                  </div>
                </div>
              </div>
            </app-info-card>
          </div>
        }
        @for (worker of workers(); track worker) {
          @if (worker.id != null) {
          <div
            class="worker-slot-card mt-3 col-md-6 col-lg-4"
            role="option"
            [id]="'worker-option-' + worker.id"
            [attr.aria-selected]="selectedWorkerId === worker.id"
            [attr.aria-label]="(worker | translation : 'resource_name' : lang) + (selectedWorkerId === worker.id ? ' - Selected' : ' - Not selected')"
            tabindex="0"
            (click)="selectedWorkerId = worker.id; onWorkerChange()"
            (keydown.enter)="selectedWorkerId = worker.id; onWorkerChange(); $event.preventDefault()"
            (keydown.space)="selectedWorkerId = worker.id; onWorkerChange(); $event.preventDefault()"
            [attr.aria-posinset]="$index + (widgetService?.widgetConf?.partner?.egal_wer_show === 1 ? 2 : 1)"
            [attr.aria-setsize]="workers().length + (widgetService?.widgetConf?.partner?.egal_wer_show === 1 ? 1 : 0)"
          >
            <app-info-card
              [showCardBorder]="true"
              [showShadow]="false"
              [showBody]="true"
              [isSelected]="selectedWorkerId === worker.id"
              [selectedCardColor]="widgetService?.widgetConf?.header_background_color"
              [customCardClass]="selectedWorkerId === worker?.id ? 'cbsw-next-icon' : ''"
              [attr.aria-label]="(worker | translation : 'resource_name' : lang) + (selectedWorkerId === worker.id ? ' - Selected' : ' - Not selected')"
              [attr.aria-pressed]="selectedWorkerId === worker.id"
              role="article"
            >
              <div cardBody role="group" [attr.aria-label]="(worker | translation : 'resource_name' : lang) + ' details'">
                <div class="d-flex align-items-center justify-content-between cbsw-workers-avatar-wrapper">
                  <div class="d-flex align-items-center cbsw-workers-avatar-sub-wrapper">
                    <div class="avatar" role="presentation">
                      @if (worker.avatar !== null) {
                        <img
                          #image
                          class="resource-avatar rounded-circle"
                          src="{{ workerAvatarBaseUrl }}{{ worker.uuid }}/thumb_{{ worker.avatar }}"
                          (error)="
                            image.src = baseUrl + '/img/sample-avatar.png';
                            image.classList.add('default-avatar-margin')
                          "
                          height="200"
                          [alt]="(worker | translation : 'resource_name' : lang) + ' avatar'"
                        />
                      } @else {
                        <img
                          class="default-avatar rounded-circle default-avatar-margin"
                          src="{{ baseUrl }}/img/sample-avatar.png"
                          height="200"
                          [alt]="(worker | translation : 'resource_name' : lang) + ' avatar'"
                        />
                      }
                    </div>
                    <div class="description" role="group" [attr.aria-label]="(worker | translation : 'resource_name' : lang) + ' information'">
                      @let cardStore = displayStore(worker);
                      @if (cardStore?.name) {
                        <div class="cbw-store-name" role="text" aria-label="Store name">
                          @if (cardStore?.is_multi_language === 1) {
                            {{ cardStore | translation : "name" : lang }}
                          }
                          @if (cardStore?.is_multi_language === 0) {
                            {{ cardStore?.name }}
                          }
                        </div>
                      }
                      <div class="cbw-title" role="heading" aria-level="3">
                        @if (worker.is_resource === 0) {
                          {{ worker.resource_name }}
                        }
                        @if (worker.is_resource === 1) {
                          @if (worker.is_multi_language === 1) {
                            {{ worker | translation : "booking_label" : lang }}
                          }
                          @if (worker.is_multi_language === 0) {
                            {{ worker.resource_name }}
                          }
                        }
                      </div>
                      @if (worker.is_resource === 0 && worker?.job_title) {
                        <div class="cbw-function title" role="text" aria-label="Job title">
                          <span [innerHTML]="worker | translation : 'job_title' : lang | calioSafe : 'html'" [attr.aria-label]="worker | translation : 'job_title' : lang"></span>
                        </div>
                      }
                      @if (worker.is_resource !== 0) {
                        <div class="cbw-function description" role="text" aria-label="Description">
                            <span [innerHTML]="worker | translation : 'description' : lang | calioSafe : 'html'" [attr.aria-label]="worker | translation : 'description' : lang | calioSafe : 'html'"></span>
                        </div>
                      }
                      <!-- Showing description for custom AMAG smart widget, By defaut it will be display:none-->
                      @if (cardStore?.logo) {
                        <div class="cbw-custom-store-logo" role="img" [attr.aria-label]="(cardStore | translation : 'name' : lang) + ' logo'">
                          <img
                            src="{{ storeBaseUrl }}{{ cardStore.uuid }}/{{ cardStore?.logo }}"
                            height="40"
                            [alt]="(cardStore | translation : 'name' : lang) + ' logo'"
                          />
                        </div>
                      }
                      <!-- Showing description for custom AMAG smart widget, By defaut it will be display:none-->
                      @if (worker?.description) {
                        <div class="cbw-custom-description" role="text" aria-label="Additional description">
                            <span [innerHTML]="worker | translation : 'description' : lang | calioSafe : 'html'" [attr.aria-label]="worker | translation : 'description' : lang"></span>
                        </div>
                      }
                      @if (widgetShowResourceStoreName === 1) {
                        <div class="cbw-worker-store-location" role="group" aria-label="Store location">
                          <span class="cbw-worker-store-location-name" role="text">{{ cardStore | translation : "name" : lang }}</span>
                          @if (cardStore.is_online === 0) {
                            <span class="cbw-worker-store-location-separator" aria-hidden="true">,&nbsp;</span>
                            <span class="cbw-worker-store-location-address whitespace-pre-line" role="text">
                              @let addressInput = {
                                street: cardStore.street,
                                zip: cardStore.zip,
                                city: cardStore.city,
                                country: cardStore.country | translation : "name" : lang,
                                country_code: cardStore.country?.identifier,
                              };
                              {{ addressInput | addressFormat: 'single' }}
                            </span>
                          }

                          @if (worker?.attributes?.length) {
                            <div class="cbw-worker-attributes" role="group" aria-label="Worker attributes">
                              @for (attribute of worker.attributes; track attribute.uuid) {
                                @if (attribute.type === workerAttributeTypes.SELECT) {
                                  <div class="attribute-container cbw-attribute-container" role="group" [attr.aria-label]="(attribute | translation: 'name': lang)">
                                    <div class="cbw-attribute" role="text">
                                      {{ attribute | translation: 'name': lang }}:
                                    </div>
                                    <div class="attribute-value-section" role="list" [attr.aria-label]="(attribute | translation: 'name': lang) + ' values'">
                                      @for (value of attribute.attributes_values; track value.uuid; let last = $last) {
                                        <div class="attribute-value-img" role="listitem">
                                          @if (value.icon_url !== null) {
                                            <img
                                              #image
                                              class="cbw-attribute-icon"
                                              [alt]="value.value"
                                              src="{{ value.icon_url }}"
                                              (error)="image.src= baseUrl + '/img/sample-avatar.png'"
                                            />
                                          }
                                          <div class="cbw-attribute-value" role="text">
                                            {{ value.value }}
                                            @if (!last) { <span aria-hidden="true">|</span> }
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  </div>
                                } @else {
                                  <div class="cbw-attribute cbw-attribute-container" role="group" [attr.aria-label]="(attribute | translation: 'name': lang)">
                                    <span role="text">{{ attribute | translation: 'name': lang }}:</span>
                                    @if (attribute.attributes_values?.length) {
                                      <span role="text">{{ +attribute.attributes_values[0].value === 1 ? ( 'yes' | translate ): ( 'no' | translate ) }}</span>
                                    }
                                  </div>
                                }
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                  <div class="next-arrow-container">
                    @if (selectedWorkerId === worker.id) {
                      <span
                        (click)="next()"
                        role="button"
                        tabindex="0"
                        [attr.aria-label]="'Continue to next step'"
                        (keydown.enter)="next(); $event.preventDefault()"
                        (keydown.space)="next(); $event.preventDefault()"
                        [attr.aria-keyshortcuts]="'Alt+ArrowRight'"
                      >
                        <div class="next-button-wrapper">
                          <img
                            [src]="baseUrl + '/images/next_icon_widget.svg'"
                            width="26px"
                            alt="Continue"
                            aria-hidden="true"
                          />
                        </div>
                      </span>
                    }
                  </div>
                </div>
              </div>
            </app-info-card>
          </div>
          }
        }
      </div>
      }

      @if (showWorkerSelectionRequiredError) {
        <div
          class="cbsw-meeting-type-selection-setp-error cbsw-global-step-error"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          [attr.aria-invalid]="true"
          [attr.aria-relevant]="'additions removals'"
          id="worker-selection-error"
        >
          <div class="text-danger">
            <div>{{ 'error_messages.select_one_option' | translate }}</div>
          </div>
        </div>
      }

      <div
        class="d-flex justify-content-end mt-4 mb-4 cbw-custom-navigation"
        role="navigation"
        aria-label="Worker selection navigation"
        [attr.aria-controls]="'worker-selection-section'"
        [attr.aria-describedby]="showWorkerSelectionRequiredError ? 'worker-selection-error' : null"
      >
        <div class="me-2">
          <app-button
            id="workers-selection-previous-btn"
            (clickEvent)="previous()"
            [fontColor]="widgetService?.widgetConf?.button_font_color"
            [backgroundColor]="widgetService?.widgetConf?.button_background_color"
            [ariaLabel]="'Go back to previous step'"
            [ariaControls]="'worker-selection-section'"
            [attr.aria-keyshortcuts]="'Alt+ArrowLeft'"
            [attr.aria-disabled]="false"
          >
            <span class="custom-button-icon back" aria-hidden="true"></span>
            {{ bookingService.widgetTemplates | calioMeetingTemplate : { id: templateConstant.WIDGET_PREVIOUS_BUTTON, type: "template" } | translation : "template_content" : lang }}
          </app-button>
        </div>
        <div>
          <app-button
            id="workers-selection-next-btn"
            (clickEvent)="next()"
            [fontColor]="widgetService?.widgetConf?.button_font_color"
            [backgroundColor]="widgetService?.widgetConf?.button_background_color"
            [ariaLabel]="'Continue to next step'"
            [ariaControls]="'worker-selection-section'"
            [attr.aria-keyshortcuts]="'Alt+ArrowRight'"
            [attr.aria-disabled]="!selectedWorkerId"
            [attr.aria-describedby]="showWorkerSelectionRequiredError ? 'worker-selection-error' : null"
          >
            {{ bookingService.widgetTemplates | calioMeetingTemplate : { id: templateConstant.WIDGET_NEXT_BUTTON, type: "template" } | translation : "template_content" : lang }}
            <span class="custom-button-icon next" aria-hidden="true"></span>
          </app-button>
        </div>
      </div>
    </div>
  </form>
}
